export function calculatePackagePricing(services = [], discountPercent = 0) {
  const original = (services || []).reduce(
    (sum, service) => sum + (Number(service.price_from) || 0),
    0,
  )
  const pct = Number(discountPercent) || 0
  const discount = original * (pct / 100)
  const discounted = Math.max(original - discount, 0)
  return {
    original,
    discount,
    discounted,
    savings: discount,
    discountPercent: pct,
  }
}

export function formatPackageDuration(services = []) {
  const totalMinutes = (services || []).reduce(
    (sum, service) => sum + (Number(service.duration_minutes) || 0),
    0,
  )
  if (totalMinutes <= 0) return '—'
  const hours = Math.floor(totalMinutes / 60)
  const mins = totalMinutes % 60
  if (hours > 0 && mins > 0) return `${hours}h ${mins}m`
  if (hours > 0) return `${hours}h`
  return `${mins}m`
}

export function formatServiceDurationMinutes(minutes) {
  const m = Number(minutes) || 0
  if (m <= 0) return '—'
  if (m >= 60) {
    const h = Math.floor(m / 60)
    const r = m % 60
    return r > 0 ? `${h} hr ${r} min` : `${h} hr`
  }
  return `${m} min`
}

export function getServiceRoleLabel(service) {
  return (
    service?.service_categories?.name ||
    service?.group ||
    service?.categoryName ||
    'Specialist'
  )
}

/** Format a deal starts_at / ends_at value for display. */
export function formatOfferDate(value) {
  if (!value) return null
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return null
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

/** Prefer offer dates; fall back to parent campaign dates when package has none. */
export function resolveOfferValiditySource(offer, parentOffer = null) {
  const starts_at = offer?.starts_at || parentOffer?.starts_at || null
  const ends_at = offer?.ends_at || parentOffer?.ends_at || null
  if (!starts_at && !ends_at) return null
  return { starts_at, ends_at }
}

/** e.g. "Valid from Sep 8, 2026 to Sep 30, 2026" or "Valid until Sep 30, 2026" */
export function formatOfferValidityRange(offer, parentOffer = null) {
  const source = resolveOfferValiditySource(offer, parentOffer) || offer
  const start = formatOfferDate(source?.starts_at)
  const end = formatOfferDate(source?.ends_at)
  if (start && end) return `Valid from ${start} to ${end}`
  if (end) return `Valid until ${end}`
  if (start) return `Valid from ${start}`
  return null
}
